var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXMark = function SvgXMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 16.828c4.36 0 7.969-3.617 7.969-7.969 0-4.359-3.617-7.968-7.977-7.968C3.641.89.032 4.5.032 8.859c0 4.352 3.616 7.97 7.968 7.97m-2.758-4.562a.652.652 0 0 1-.453-1.11l2.29-2.289-2.29-2.289a.638.638 0 0 1 .453-1.094.6.6 0 0 1 .453.188L7.992 7.96l2.32-2.297a.6.6 0 0 1 .446-.195c.351 0 .64.289.64.64 0 .18-.054.32-.187.461L8.914 8.867l2.29 2.281a.64.64 0 0 1 .187.461c0 .36-.29.657-.649.657a.67.67 0 0 1-.46-.196l-2.29-2.289-2.273 2.29a.66.66 0 0 1-.477.195"
  })));
};
export default SvgXMark;